import { render } from "./PlanetTextBody.vue?vue&type=template&id=e6b35db8&scoped=true"
import script from "./PlanetTextBody.vue?vue&type=script&lang=js"
export * from "./PlanetTextBody.vue?vue&type=script&lang=js"

import "./PlanetTextBody.vue?vue&type=style&index=0&id=e6b35db8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b35db8"]])

export default __exports__